import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["track", "tab", "counter"]

  connect() {
    this.index = 0
    this.total = this.tabTargets.length
  }

  switchTo(event) {
    this.go(parseInt(event.currentTarget.dataset.index))
  }

  prev() {
    this.go((this.index - 1 + this.total) % this.total)
  }

  next() {
    this.go((this.index + 1) % this.total)
  }

  go(i) {
    this.index = i
    this.trackTarget.style.transform = `translateX(-${i * 100}%)`
    this.tabTargets.forEach((tab, idx) => {
      tab.classList.toggle("text-white",          idx === i)
      tab.classList.toggle("border-accent",       idx === i)
      tab.classList.toggle("text-slate-500",      idx !== i)
      tab.classList.toggle("border-transparent",  idx !== i)
    })
    if (this.hasCounterTarget) {
      this.counterTarget.textContent = `${i + 1} de ${this.total}`
    }
  }
}
